import { useParams } from 'react-router-dom';
import CreateCreditDebitNote from './CreateCreditNote';

const EditCreditNote = () => {
    const { id } = useParams();
    return <CreateCreditDebitNote noteType="CREDIT_NOTE" noteId={id} />;
};

export default EditCreditNote;
